import { render } from "./MarketplaceCard.vue?vue&type=template&id=0386537c"
import script from "./MarketplaceCard.vue?vue&type=script&lang=js"
export * from "./MarketplaceCard.vue?vue&type=script&lang=js"

import "./MarketplaceCard.vue?vue&type=style&index=0&id=0386537c&lang=scss"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__